<script lang="ts">
  import { between } from "polished";

  export let cssCalc = between("1.8rem", "2.4rem", "32rem", "72rem");
</script>

<p style="--interpolation:{cssCalc}"><slot /></p>

<style>
  p {
    font-family: var(--body-font);
    font-kerning: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-variant-ligatures: common-ligatures contextual;
    font-size: clamp(1.8rem, var(--interpolation), 2.4rem);
    font-weight: 300;
    line-height: 1.5;
    text-rendering: optimizeLegibility;
    color: var(--color-text);
  }
  p:first-child {
    margin-top: 0;
  }
</style>
